import { getMonth, getYear } from 'date-fns';
export var createActiveMonth = src => {
  var month = getMonth(src);
  var year = getYear(src); // eslint-disable-next-line no-restricted-syntax

  var date = new Date(year, month, 15, 12);
  return {
    month,
    year,
    date
  };
};
//# sourceMappingURL=createActiveMonth.js.map